const createRadio = function(name, action, data) {
  const label = document.createElement("label");
  label.className = "radio";

  const input = document.createElement("input");
  input.type = "radio";
  input.name = name;
  input.value = data.value;
  input.setAttribute("data-action", action);

  label.appendChild(input);
  label.innerHTML += data.label;

  if(data.labelClass) {
    label.classList.add(data.labelClass);
  }

  return label;
}

const openAndScroll = function(to, from) {
  if(to.classList.contains("closed")) {
    to.classList.remove("closed");
    window.scrollTo({
      top: from.offsetTop + 20,
      behavior: 'smooth',
    });
  }
}

const validatePhone = function(phone) {
  const re = /[0-9]{8}/;
  if(phone.match(re)) {
    return true;
  }

  return false;
}

export {
  createRadio,
  openAndScroll,
  validatePhone,
};

